import { getFeatureFlags, isFeatureFlagEnabled } from './utils';

export interface FeatureOptions {
  featureName: string;
  domainName: string;
}
export interface UseFeatureFlagsReturnType {
  isFeatureFlagEnabled: (options: FeatureOptions) => Promise<boolean>;
  getFeatureFlags: () => Promise<Record<string, unknown>>;
}

export const useFeatureFlags = (): UseFeatureFlagsReturnType => {
  return {
    isFeatureFlagEnabled: async (options: FeatureOptions) => isFeatureFlagEnabled(options),
    getFeatureFlags: async () => getFeatureFlags(),
  };
};
